import days from 'dayjs'

// This function returns months list for the plan
// It returns {monthToLoad}' months, {monthToLoad/2} months before and {monthToLoad/2} months after the current month
function getPlanMonthList(monthCount = 26) {
  if (monthCount % 2 !== 0) {
    throw new Error('Month count should be even')
  }

  const now = new Date()

  const startFrom = days(now)
    .subtract(monthCount / 2, 'month')
    .toDate()

  const months = []

  for (let i = 0; i <= monthCount; i++) {
    months.push(days(startFrom).add(i, 'month').toDate())
  }

  const formatted = months.map((date) => days(date).format('MM-YYYY'))

  return {
    dates: months,
    fromMonth: months[0],
    toMonth: months[months.length - 1],
    formatted,
    fromMonthFormatted: formatted[0],
    toMonthFormatted: formatted[formatted.length - 1],
  }
}

export { getPlanMonthList }
